import { render, staticRenderFns } from "./GroupDashboard.vue?vue&type=template&id=0a7f03a4&scoped=true"
import script from "./GroupDashboard.vue?vue&type=script&lang=js"
export * from "./GroupDashboard.vue?vue&type=script&lang=js"
import style0 from "./GroupDashboard.vue?vue&type=style&index=0&id=0a7f03a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7f03a4",
  null
  
)

export default component.exports